import { ValidationError } from '@tradgine/data-access/backend-errors';

export function formatValidationError(error: ValidationError): string {
    const lines: string[] = [];

    if (error.title) {
        lines.push(error.title);
    }

    if (error.errors) {
        for (const msgs of Object.values(error.errors)) {
            for (const m of msgs) {
                lines.push(m);
            }
        }
    }

    return lines.join('\n');
}
